.table {
  width: 100%;
}
.table .tr {
  border-radius: 2px;
}
.table .added {
  background-color: #cfc;
  color: #006600;
}
.table .removed {
  background-color: #fcc;
  color: #660000;
}
.table .place {
  font-size: 0.85em;
  opacity: 0.7;
  text-align: right;
  padding-right: 6px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhpc3RvcnlWaWV3LnNhc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUUE7RUFDRTs7QUFDQTtFQUNFOztBQUNGO0VBQ0Usa0JBWGE7RUFZYixPQVRhOztBQVVmO0VBQ0Usa0JBYmU7RUFjZixPQVhlOztBQVlqQjtFQUNFO0VBQ0E7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiQHVzZSBcInNhc3M6Y29sb3JcIlxuXG4kYWRkZWQtY29sb3ItYmc6ICNjZmNcbiRyZW1vdmVkLWNvbG9yLWJnOiAjZmNjXG5cbiRhZGRlZC1jb2xvci1mZzogY29sb3IuYWRqdXN0KCRhZGRlZC1jb2xvci1iZywgJGxpZ2h0bmVzczogLTcwJSwgJHNwYWNlOiBoc2wpXG4kcmVtb3ZlZC1jb2xvci1mZzogY29sb3IuYWRqdXN0KCRyZW1vdmVkLWNvbG9yLWJnLCAkbGlnaHRuZXNzOiAtNzAlLCAkc3BhY2U6IGhzbClcblxuLnRhYmxlXG4gIHdpZHRoOiAxMDAlXG4gIC50clxuICAgIGJvcmRlci1yYWRpdXM6IDJweFxuICAuYWRkZWRcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkYWRkZWQtY29sb3ItYmdcbiAgICBjb2xvcjogJGFkZGVkLWNvbG9yLWZnXG4gIC5yZW1vdmVkXG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHJlbW92ZWQtY29sb3ItYmdcbiAgICBjb2xvcjogJHJlbW92ZWQtY29sb3ItZmdcbiAgLnBsYWNlXG4gICAgZm9udC1zaXplOiAwLjg1ZW1cbiAgICBvcGFjaXR5OiAwLjdcbiAgICB0ZXh0LWFsaWduOiByaWdodFxuICAgIHBhZGRpbmctcmlnaHQ6IDZweFxuIl19 */